<template>
  <div class="container">
    <Header />
    <b-card>
      <p>お問い合わせの一覧および回答は、<a href="https://docs.google.com/spreadsheets/d/1v0cEq16vOEjeV4QwSSdpR4yTXnoNAwe6bXZ9rTN9WPQ/edit?usp=sharing" target="_blank">こちら(Googleスプレッドシート)</a>からご覧ください。</p>
      <b-card-text>
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfi_o2AkdUzr5PjBX4ZTjpYHbmGq3xdXLLLvevNZokhoi7ncA/viewform?embedded=true" width="100%" height="600px" frameborder="0" marginheight="0" marginwidth="0">読み込んでいます…</iframe>
      </b-card-text>

      <!-- <b-tabs card>
      //   <b-tab title="フォーム" active>
      //     <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfi_o2AkdUzr5PjBX4ZTjpYHbmGq3xdXLLLvevNZokhoi7ncA/viewform?embedded=true" width="100%" height="600px" frameborder="0" marginheight="0" marginwidth="0">読み込んでいます…</iframe>
      //   </b-tab>
      //   <b-tab title="一覧">
      //     <iframe src="https://docs.google.com/spreadsheets/d/e/2PACX-1vTlu9nkziW8HwwbzQ88ErcZl1LTyzdJ4fMGV8Vze2bfalOZ2pugMZ2d5ys7BDlyRmEjonm95LK78oRd/pubhtml?widget=true&amp;headers=false" width="100%" height="600px" frameborder="0" marginheight="0" marginwidth="0"></iframe>
      //   </b-tab>
      // </b-tabs> -->
    </b-card>
  </div>
</template>

<style>
</style>

  <script>
  import Header from '@/components/Header.vue'
  // import firebase from 'firebase/app'
  // import 'firebase/auth'
  // import 'firebase/database'
  // import router from '../router'

  export default {
    name: 'inquiry',
    created: function() {
    },
    data() {
      return {
      }
    },
    computed: {
    },
    components: {
      Header,
    },
    methods: {

    },
    filters: {
    },
  }
  </script>
